/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PopulateOverwolfCachesTestResponse
 */
export interface PopulateOverwolfCachesTestResponse {
    /**
     * Raw data mapper cache keys populated
     * @type {Array<string>}
     * @memberof PopulateOverwolfCachesTestResponse
     */
    rawDataMapperKeys: Array<string>;
    /**
     * Quest config cache keys populated
     * @type {Array<string>}
     * @memberof PopulateOverwolfCachesTestResponse
     */
    questConfigKeys: Array<string>;
}

/**
 * Check if a given object implements the PopulateOverwolfCachesTestResponse interface.
 */
export function instanceOfPopulateOverwolfCachesTestResponse(value: object): value is PopulateOverwolfCachesTestResponse {
    if (!('rawDataMapperKeys' in value) || value['rawDataMapperKeys'] === undefined) return false;
    if (!('questConfigKeys' in value) || value['questConfigKeys'] === undefined) return false;
    return true;
}

export function PopulateOverwolfCachesTestResponseFromJSON(json: any): PopulateOverwolfCachesTestResponse {
    return PopulateOverwolfCachesTestResponseFromJSONTyped(json, false);
}

export function PopulateOverwolfCachesTestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopulateOverwolfCachesTestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rawDataMapperKeys': json['rawDataMapperKeys'],
        'questConfigKeys': json['questConfigKeys'],
    };
}

export function PopulateOverwolfCachesTestResponseToJSON(json: any): PopulateOverwolfCachesTestResponse {
    return PopulateOverwolfCachesTestResponseToJSONTyped(json, false);
}

export function PopulateOverwolfCachesTestResponseToJSONTyped(value?: PopulateOverwolfCachesTestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rawDataMapperKeys': value['rawDataMapperKeys'],
        'questConfigKeys': value['questConfigKeys'],
    };
}

